const ArrowRightIcon: React.FC<{ size?: string }> = ({ size = "24" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ stroke: "currentColor", fill: "currentColor" }}
    >
      <path
        d="M15.7501 9.525L11.1641 4.939C10.8827 4.65774 10.5011 4.49978 10.1033 4.49988C9.70543 4.49997 9.3239 4.65811 9.04264 4.9395C8.76138 5.2209 8.60342 5.6025 8.60352 6.00036C8.60361 6.39822 8.76175 6.77974 9.04314 7.061L13.6291 11.646C13.6757 11.6925 13.7126 11.7476 13.7379 11.8084C13.7631 11.8691 13.776 11.9342 13.776 12C13.776 12.0658 13.7631 12.1309 13.7379 12.1916C13.7126 12.2524 13.6757 12.3076 13.6291 12.354L9.04314 16.939C8.76175 17.2203 8.60361 17.6018 8.60352 17.9997C8.60342 18.3975 8.76138 18.7791 9.04264 19.0605C9.3239 19.3419 9.70543 19.5 10.1033 19.5001C10.5011 19.5002 10.8827 19.3423 11.1641 19.061L15.7501 14.475C16.4054 13.818 16.7733 12.9279 16.7733 12C16.7733 11.0721 16.4054 10.182 15.7501 9.525Z"
      />
    </svg>
  );
};

export default ArrowRightIcon;
